import cn from 'classnames'
import {FC} from 'react'

import {AcademyBanner} from '@/components/common/banner/AcademyBanner'
import {BLOG_SIDEBAR_WIDTH, HEADER_HEIGHT_DESKTOP} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type BlogSidebarProps = {
  fullWidth?: boolean
}

export const BlogSidebar: FC<React.PropsWithChildren<BlogSidebarProps>> = ({fullWidth}) => {
  return (
    <>
      <aside className={cn('sidebar', fullWidth && 'full-width')}>
        <AcademyBanner isCentered />
      </aside>

      <style jsx>{`
        .sidebar {
          position: sticky;
          top: calc(${HEADER_HEIGHT_DESKTOP} + ${theme.spacing[4]});
          height: 100%;
          max-width: ${BLOG_SIDEBAR_WIDTH};
          flex: 1;
          margin-left: ${theme.spacing[9]};
        }
        .sidebar.full-width {
          max-width: 600px;
          margin: 0 auto;
        }
        @media ${TABLET_SCREENSIZE} {
          .sidebar {
            position: relative;
            top: 0;
            max-width: inherit;
            margin-left: 0;
            margin-top: ${theme.spacing[7]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .sidebar {
            margin-top: ${theme.spacing[6]};
          }
        }
      `}</style>
    </>
  )
}
